// import type { DropdownOption } from 'types/ui'

type DropdownOption = {
  value: string | number
  label: string
  blank?: boolean
}

export const getDropdownOptionFromArray: (
  list: string[],
) => DropdownOption[] = list =>
  list.map(l => ({
    value: l,
    label: l,
  }))
const performingRightsOrganizations = [
  'ACEMLA',
  'ACUM',
  'AEPI',
  'AGADU',
  'AKM',
  'APDAYC',
  'APRA',
  'ARTISJUS',
  'ASCAP',
  'BMI',
  'BUMA',
  'CASH',
  'CMRRA',
  'COMPASS',
  'COTT',
  'EAU',
  'ECAD',
  'FILSCAP',
  'GEMA',
  'GMR',
  'HDS',
  'Irish Music Rights Organisation, PPI',
  'JASRAC',
  'KODA',
  'KOMCA',
  'LATGA-A',
  'MACP',
  'MCT',
  'MRCSN',
  'MUSICAUTHOR',
  'MUST',
  'OSA',
  'PPL',
  'PRS',
  'RAO',
  'Re:Sound Music Licensing Company',
  'SABAM',
  'SACEM',
  'SACM',
  'SACVEN',
  'SADAIC',
  'SAMRO',
  'SAS',
  'SAYCO/ACINPRO',
  'SCD',
  'SESAC',
  'SGAE',
  'SIAE',
  'SOCAN',
  'SODRAC',
  'SOKOJ',
  'SOZA',
  'SPAC',
  'SPACQ',
  'STIM',
  'SUISA',
  'Teosto',
  'The Indian Performing Right Society Ltd',
  'TONO',
  'UACRR',
  'UCMR',
  'ZAIKS',
]
// full list:
// https://en.wikipedia.org/wiki/List_of_copyright_collection_societies
export const PRODropdownOptions: DropdownOption[] = [
  {
    value: '',
    label: 'Writer PRO',
    blank: true,
  },
  ...performingRightsOrganizations.map(org => ({
    value: org,
    label: org,
  })),
]
export const tracksPlanOptions = [
  1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000,
]
